<template>
  <div class="mb-3">
    <custom-callout
      :border-color="data.status.color"
      controlled
      has-toggle
      :opened="data.opened"
      @click:open="open"
    >
      <div class="row py-2 mr-md-0 n-ml">
        <div class="col-12 col-md text-center border-right">
          <div
            :class="`badge badge-pill font-16 mt-3 py-2 mx-auto color-black`"
            :style="{ 'background-color': data.status.color }"
          >
            {{ data.status.name }}
          </div>
          <div>
            <span class="font-16 color-black ">
              {{ data.number | empty }}
            </span>
          </div>
        </div>
        <div class="col-12 col-md-10">
          <div class="row pt-2">
            <div class="col-12 col-md custom-pl">
              <div class="d-flex flex-column">
                <span class="color-gray-6 d-block font-14">
                  Año Fiscal:
                </span>
                <span class="font-16 color-black font-weight-bold">
                  {{ data.academicYear.name | empty }}
                </span>
              </div>
            </div>
            <div class="col-12 col-md custom-pl">
              <div class="d-flex flex-column">
                <span class="color-gray-6 d-block font-14">
                  Fecha de Solicitud:
                </span>
                <span class="font-16 color-black font-weight-bold">
                  {{ data.requestDate | date }}
                </span>
              </div>
            </div>
            <div class="col-12 col-md custom-pl">
              <div class="d-flex flex-column">
                <span class="color-gray-6 d-block font-14">
                  Tipo de Contratación:
                </span>
                <span class="font-16 color-black font-weight-bold">
                  {{ data.contractType.name }}
                </span>
              </div>
            </div>
            <div class="col-12 col-md custom-pl">
              <div class="d-flex flex-column">
                <span class="color-gray-6 d-block font-14">
                  Nombre:
                </span>
                <span class="font-16 color-black font-weight-bold">
                  {{ data.name | empty }}
                </span>
              </div>
            </div>
            <div class="col-12 col-md custom-pl text-md-center">
              <div class="d-flex flex-column">
                <dropdown
                  class="actions-dropdown"
                  :items="actionItems"
                  title="Acciones"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #edition>
        <div class="p-2 bg-gray">
          <div class="p-3 bg-white">
            <determinate
              v-if="showDeterminate"
              :id="data.id"
              :categories="determinationTypes"
              @close="closeDeterminate"
              @saved="onDeterminated"
            />
            <determination
              v-else-if="canSeeDetermination"
              :item="data"
              @close="closeDetermination"
            />
            <history v-else-if="canSeeHistory" :item="data" />
            <custom-tab
              v-else
              content-class="mt-3"
              nav-class="nav-vue-underline psf-custom-tab"
              :no-nav-style="true"
            >
              <custom-tab-item class="mt-2" title="Información Adicional">
                <div class="row mx-0 mt-4 px-2 mb-3">
                  <div class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column">
                    <span class="color-gray-6 d-block font-14">
                      Área:
                    </span>
                    <span class="font-16 color-black font-weight-bold">
                      {{ data.area?.name | empty }}
                    </span>
                  </div>
                  <div class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column">
                    <span class="color-gray-6 d-block font-14">
                      Servicio a Ofrecer:
                    </span>
                    <span class="font-16 color-black font-weight-bold">
                      {{ data.service?.name | empty }}
                    </span>
                  </div>
                  <div class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column">
                    <span class="color-gray-6 d-block font-14">
                      Usuario Solicitante:
                    </span>
                    <span class="font-16 color-black font-weight-bold">
                      {{ data.createdBy?.name | empty }}
                    </span>
                  </div>
                </div>
              </custom-tab-item>
            </custom-tab>
          </div>
        </div>
      </template>
    </custom-callout>
    <div v-if="comment.show" class="bg-secondary-3 rounded">
      <div class="p-2">
        <div class="p-3 bg-white">
          <icon-view
            class="mt-5 mb-3 mt-md-0 mt-sm-5"
            :icon="`mb-1 ${comment.icon}`"
            :icon-color="comment.iconColor"
            icon-size="16px"
            :title="comment.title"
          />
          <validation-observer ref="commentForm" novalidate>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                v-model="comment.model.comment"
                :count-classes="['d-block', 'small-counter']"
                custom-error-msg="El campo es requerido."
                :error="errors[0]"
                label="Comentario:"
                :maxlength="3000"
              />
            </validation-provider>
            <div class="mt-3 bg-secondary-3 p-3 rounded">
              <div class="data-name mb-2">
                Archivo:
              </div>
              <custom-file-input
                ref="commentFileUpload"
                v-model="comment.model.file"
                accept=".pdf"
                display-style="normal"
                :on-download="() => {}"
              />
            </div>

            <div class="d-flex justify-content-end align-items-center mt-4">
              <action-button
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger mr-2"
                @click="cancelComment"
              />
              <action-button
                i="fas fa-save"
                text="Guardar"
                variant="success"
                @click="changeStatus()"
              />
            </div>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//libs components
import CustomCallout from 'custom-callout';
import Dropdown from 'dropdown';
import CustomTextArea from 'CustomTextArea';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import Determinate from './Determinate.vue';
import Determination from './Determination.vue';
import History from './History.vue';

import _generalApi from '@/modules/app/api';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import purchaseServiceStatus, {
  purchaseServiceStatusColor as StatusColor,
} from '@/utils/constants/PurchaseServiceStatus';

import CONTRACT_TYPE from '@/utils/constants/purchaseServiceContractType';

const ANNOUNCEMENT_STATUS = Object.freeze({
  Draft: 1,
  Published: 2,
  Finished: 3,
});

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    Dropdown,
    CustomTextArea,
    CustomFileInput,
    ActionButton,
    IconView,
    CustomTab,
    CustomTabItem,
    Determinate,
    Determination,
    History,
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    determinationTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      comment: {
        show: false,
        title: null,
        icon: null,
        iconColor: null,
        model: {},
      },
      showDeterminate: false,
      showDetermination: false,
      showHistory: false,
    };
  },
  computed: {
    canCreateAnnouncement() {
      const statuses = [purchaseServiceStatus.Determined];
      if (this.data.contractType?.id !== CONTRACT_TYPE.New)
        statuses.push(purchaseServiceStatus.Signed);

      return (
        this.userHasPermissions(
          'purchaseproposal.view.documentannouncement.create'
        ) &&
        statuses.includes(this.data.status?.id) &&
        !this.data.determinationAnnouncement
      );
    },
    canViewAnnouncement() {
      return (
        [
          purchaseServiceStatus.Determined,
          purchaseServiceStatus.Signed,
          purchaseServiceStatus.Awarded,
        ].includes(this.data.status?.id) &&
        [ANNOUNCEMENT_STATUS.Published, ANNOUNCEMENT_STATUS.Finished].includes(
          this.data.determinationAnnouncement?.status?.id
        )
      );
    },
    canEditAnnouncement() {
      return (
        [
          purchaseServiceStatus.Determined,
          purchaseServiceStatus.Signed,
        ].includes(this.data.status?.id) &&
        this.data.determinationAnnouncement?.status?.id ==
          ANNOUNCEMENT_STATUS.Draft
      );
    },
    canSeeDetermination() {
      return (
        this.showDetermination &&
        this.data.status?.id === purchaseServiceStatus.Determined &&
        !!this.data.determinationCategory
      );
    },
    canSeeHistory() {
      return this.showHistory;
    },
    canViewSignDocument() {
      return (
        this.data.status?.id === purchaseServiceStatus.Approved &&
        !!this.data.signedDocumentId
      );
    },
    purchaseServiceStatusValue() {
      return purchaseServiceStatus;
    },
    shouldBeRemoveActionVisible() {
      return (
        this.userHasPermissions('provider.psf.service.requests.delete') &&
        this.data.status.id == purchaseServiceStatus.Draft
      );
    },
    shouldBeDetermineActionVisible() {
      return (
        this.userHasPermissions('provider.psf.service.requests.determinate') &&
        this.data.status.id === purchaseServiceStatus.Signed &&
        this.data.contractType.id === CONTRACT_TYPE.New
      );
    },
    shouldBeDeterminationActionVisible() {
      return this.data.status.id === purchaseServiceStatus.Determined;
    },
    actionItems() {
      let actions = [
        {
          name: 'edit',
          label: 'Editar',
          icon: 'fas fa-edit text-green pr-1',
          visible: !this.data.isSubmitted,
          click: () => {
            this.$router.push({
              name: 'purchaseServiceDetail',
              params: {
                id: this.data.id,
              },
            });
          },
        },
        {
          name: 'history',
          label: 'Historial',
          icon: 'fas fa-clock text-green',
          visible: true,
          click: () => {
            this.showHistory = true;
            this.data.opened = true;
          },
        },
        {
          name: 'view',
          label: 'Entrar',
          icon: 'fas fa-file-import text-green pr-1',
          visible: this.data.isSubmitted,
          click: () => {
            this.$router.push({
              name: 'purchaseServiceDetail',
              params: {
                id: this.data.id,
              },
            });
          },
        },
        {
          name: 'remove',
          label: 'Eliminar',
          icon: 'fas fa-times-circle text-danger pr-1',
          visible: this.shouldBeRemoveActionVisible,
          click: async () => {
            const answer = await this.ShowCancelModal(
              'Confirmación',
              `¿Está seguro que desea eliminar esta solicitud?`,
              'Si',
              'No'
            );

            if (!answer) return;
            this.$emit('remove', this.data.id);
          },
        },
        {
          name: 'determine',
          label: 'Determinar',
          icon: 'fas fa-file text-green pr-1',
          visible: this.shouldBeDetermineActionVisible,
          click: () => {
            this.showDeterminate = true;
            this.data.opened = true;
          },
        },
        {
          name: 'determination',
          label: 'Ver Determinación',
          icon: 'fas fa-file-import text-green pr-1',
          visible: this.shouldBeDeterminationActionVisible,
          click: () => {
            this.showDetermination = true;
            this.data.opened = true;
          },
        },
        {
          name: 'create-announcement',
          label: 'Documentar Pliego',
          icon: 'fas fa-plus-square text-green pr-1',
          visible: this.canCreateAnnouncement,
          click: () => this.goToCreateAnnouncement(),
        },
        {
          name: 'view-announcement',
          label: 'Ver Pliego',
          icon: 'fas fa-file-import text-green pr-1',
          visible: this.canViewAnnouncement,
          click: () => this.goToAnnouncement(),
        },
        {
          name: 'edit-announcement',
          label: 'Editar Pliego',
          icon: 'fas fa-pen-square text-green pr-1',
          visible: this.canEditAnnouncement,
          click: () => this.goToAnnouncement(),
        },
        {
          name: 'print',
          label: 'Imprimir',
          icon: 'fas fa-print text-green pr-1',
          visible: this.data.signedDocumentId !== null,
          click: () => this.downloadPurchaseService(),
        },
        {
          name: 'inReview',
          label: 'Pasar a Revisión',
          icon: 'fas fa-file-exclamation text-green pr-1',
          visible:
            this.userHasPermissions('provider.psf.service.requests.review') &&
            this.data.status.id == purchaseServiceStatus.Submitted,
          click: () => this.changeStatus(purchaseServiceStatus.UnderReview),
        },
        {
          name: 'approve',
          label: 'Aprobar',
          icon: 'fas fa-check-circle text-green pr-1',
          visible:
            this.userHasPermissions('provider.psf.service.requests.approve') &&
            this.data.status.id == purchaseServiceStatus.UnderReview,
          click: () => this.changeStatus(purchaseServiceStatus.Approved),
        },
        {
          name: 'return',
          label: 'Devolver',
          icon: 'fas fa-undo text-brown pr-1',
          visible:
            this.userHasPermissions('provider.psf.service.requests.return') &&
            this.data.status.id == purchaseServiceStatus.UnderReview,
          click: () => {
            this.comment.show = true;
            this.comment.title = 'Devolver';
            this.comment.icon = 'fas fa-undo';
            this.comment.iconColor = StatusColor.Returned;
            this.comment.model.statusId = purchaseServiceStatus.Returned;
          },
        },
        {
          name: 'reject',
          label: 'Rechazar',
          icon: 'fas fa-times-circle text-danger pr-1',
          visible:
            this.userHasPermissions('provider.psf.service.requests.reject') &&
            this.data.status.id == purchaseServiceStatus.UnderReview,
          click: () => {
            this.comment.show = true;
            this.comment.title = 'Rechazar';
            this.comment.icon = 'fas fa-times-circle';
            this.comment.iconColor = StatusColor.Rejected;
            this.comment.model.statusId = purchaseServiceStatus.Rejected;
          },
        },
        {
          name: 'sign',
          label: 'Firmar',
          icon: 'fas fa-pen-alt text-green pr-1',
          visible: this.canViewSignDocument,
          click: () => this.changeStatus(purchaseServiceStatus.Signed),
        },
      ];

      return actions;
    },
  },
  methods: {
    async downloadPurchaseService() {
      await _generalApi.downloadDocumentByAttachmentId(
        this.data.signedDocumentId
      );
    },
    cancelComment() {
      this.comment.show = false;
      this.comment.title = null;
      this.comment.icon = null;
      this.comment.iconColor = null;
      this.comment.model = {};
      this.$refs.commentFileUpload?.removeFile();
    },
    async changeStatus(statusId) {
      if (!statusId) {
        const isValid = await this.$refs.commentForm.validate();
        if (!isValid) return;
      }
      let payload = statusId ? { statusId } : this.comment.model;

      const callback = async () => {
        this.cancelComment();
      };

      this.$emit('change-status', this.data.id, payload, callback);
    },
    open() {
      this.data.opened = !this.data.opened;
      if (this.showDeterminate) this.showDeterminate = false;
      if (this.showDetermination) this.showDetermination = false;
      if (this.showHistory) this.showHistory = false;
    },
    async onDeterminated() {
      await this.askForAnnouncement();
      this.closeDeterminate();
      this.$emit('reload');
    },
    async askForAnnouncement() {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        '¿Desea proceder con la documentación del pliego?',
        'Si',
        'No'
      );
      if (confirmed) this.goToCreateAnnouncement();
    },
    goToCreateAnnouncement() {
      this.$router.push({
        name: 'BidDocumentationAdd',
        query: { cp_ps: this.data.id },
      });
    },
    goToAnnouncement() {
      this.$router.push({
        name: 'BidDocumentationEdit',
        params: { id: this.data.determinationAnnouncement.id },
      });
    },
    closeDeterminate() {
      this.showDeterminate = false;
      this.data.opened = false;
    },
    closeDetermination() {
      this.showDetermination = false;
      this.data.opened = false;
    },
    closeHistory() {
      this.showHistory = false;
      this.data.opened = false;
    },
  },
};
</script>
<style lang="css" scoped>
::v-deep .psf-custom-tab .nav-item .nav-link.active {
  border-bottom: 3px solid #ff7058 !important;
  color: #ff7058 !important;
  font-weight: 700;
}
</style>
